import React, { useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import {
  BadgeStatusEntrega,
  Btn,
  CustomDataTableHeader,
  CustomPanel,
  DateTime,
  Loading,
  PageHeader,
  Periodo,
  SelectEmpresas,
  ThreeDots,
} from '../../../../../components'

import * as colors from '../../../../../assets/js/colors'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { menuItemsAllowed } from '../../../../../services/permission/menus'
import ModalEmitirCte from '../../RetornoVeiculoApuracao/Cte/ModalEmitirCte'
import ModalEmitirCteEmpresaCliente from '../../RetornoVeiculoApuracao/Cte/ModalEmitirCteEmpresaCliente'
import ModalEmitirCteSemNota from './CteSemNota/ModalEmitirCteSemNota'
import { getDeliveriesForCte } from '../../../../../services/api/https/deliveries/delivery.http'
import { getPeriodoMesAtual } from '../../../../../services/util/date.service'
import { getEmpresas } from '../../../../../services/localstorage/localstorage.service'

function EmissaoCte({ dispatch, selectedTp, history }) {
  // Hooks
  const [entregas, setEntregas] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [modalCte, setModalCte] = useState({ show: false, data: null, consolidado: null })
  const [modalCteEmpresaCliente, setModalCteEmpresaCliente] = useState({ show: false })
  const [modalCteSemNota, setModalCteSemNota] = useState({ show: false })
  const [selectedEmpresa, setSelectedEmpresa] = useState(getEmpresas()[0].id)
  const [periodo, setPeriodo] = useState(getPeriodoMesAtual())

  const entregasEmpresaCliente = useMemo(
    () => entregas.map(entrega => ({ ...entrega, qte_sku: entrega.qteSkuTotal })),
    [entregas],
  )

  // Events
  const onMenuItemClicked = (menuItem, entrega) => {
    try {
      switch (menuItem) {
        case 'Emitir CTe':
          setModalCte({ show: true, data: entrega, consolidado: null })
          break
        default:
          throw new Error('Item do Incorreto')
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onEmitirCteEmpresaClienteClicked = () => {
    try {
      if (!entregas.length) {
        throw new Error('Pesquise as Notas Fiscais antes de emitir o CTe Empresa-Cliente')
      }
      setModalCteEmpresaCliente({ show: true })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onEmitirCteSemNotaClicked = () => {
    if (!selectedTp) {
      onError(new Error('Selecione o Operador Logístico'))
      return
    }
    setModalCteSemNota({ show: true })
  }

  const podeEmitirCte = menuItemsAllowed([{ id: 40, content: "3.18 - Gestão de CTe's" }]).length > 0

  const onPesquisar = (pInicial, pFinal) => {
    try {
      if (!selectedTp) throw new Error('Selecione o Operador Logístico')
      if (!selectedEmpresa) throw new Error('Selecione a Empresa Desejada')
      setIsLoading(true)
      setPeriodo({ dataInicial: pInicial, dataFinal: pFinal })
      getEntregas(pInicial, pFinal)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Helper
  const getEntregas = async (pInicial = periodo.dataInicial, pFinal = periodo.dataFinal) => {
    try {
      setIsLoading(true)
      const fetchedEntregas = await getDeliveriesForCte(
        selectedTp,
        selectedEmpresa,
        pInicial,
        pFinal,
      )

      setEntregas(fetchedEntregas)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  // Render
  return (
    <>
      <PageHeader>Emissão de Cte</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid" style={{ marginLeft: 0 }}>
            <div className="p-col-3">
              <SelectEmpresas
                onChange={empresa => setSelectedEmpresa(empresa.id)}
                companyId={selectedEmpresa}
              />
            </div>
            <div className="p-col-9" style={{ display: 'flex' }}>
              <Periodo
                periodoFinal={periodo.dataFinal}
                periodoInicial={periodo.dataInicial}
                onPesquisar={onPesquisar}
              />
              <div style={{ marginLeft: 10, paddingTop: 27 }}>
                <Btn
                  backgroundColor={colors.verde_escuro}
                  onClick={onEmitirCteEmpresaClienteClicked}
                  style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
                >
                  Emitir CTe Empresa-Cliente
                </Btn>
                {podeEmitirCte && (
                  <>
                    <Btn
                      backgroundColor={colors.azul_escuro}
                      onClick={onEmitirCteSemNotaClicked}
                      style={{
                        minWidth: 'auto',
                        padding: '14px',
                        borderRadius: '10px',
                        marginLeft: 10,
                      }}
                    >
                      CTe sem Nota Fiscal
                    </Btn>
                    <Btn
                      backgroundColor={colors.laranja}
                      onClick={() => history.push('/main/entregas/emissao-cte-subcontratacao')}
                      style={{
                        minWidth: 'auto',
                        padding: '14px',
                        borderRadius: '10px',
                        marginLeft: 10,
                      }}
                    >
                      CTe de Subcontratação
                    </Btn>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="p-col-12">
            {isLoading ? (
              <div className="text-center" style={{ marginTop: 20 }}>
                <Loading />
              </div>
            ) : (
              <DataTableComponent entregas={entregas} onMenuItemClicked={onMenuItemClicked} />
            )}
          </div>
        </CustomPanel>

        <ModalEmitirCte
          selectedTp={selectedTp}
          delivery={modalCte.data}
          consolidado={modalCte.consolidado}
          visible={modalCte.show}
          onModalClose={() => {
            setModalCte({ show: false, data: null, consolidado: null })
          }}
          onModalSave={() => {
            dispatch(showMessageBox('CTe enviada para emissão, aguardando resposta SEFAZ', null))

            setModalCte({ show: false, data: null, consolidado: null })
            getEntregas()
          }}
          onError={onError}
        />

        <ModalEmitirCteEmpresaCliente
          visible={modalCteEmpresaCliente.show}
          entregas={entregasEmpresaCliente}
          empresaFixa={true}
          onModalClose={() => setModalCteEmpresaCliente({ show: false })}
          onCadastrar={consolidado => {
            setModalCteEmpresaCliente({ show: false })
            setModalCte({ show: true, data: null, consolidado })
          }}
          onError={onError}
        />

        <ModalEmitirCteSemNota
          selectedTp={selectedTp}
          visible={modalCteSemNota.show}
          onModalClose={() => setModalCteSemNota({ show: false })}
          onModalSave={() => {
            dispatch(showMessageBox('CTe enviada para emissão, aguardando resposta SEFAZ', null))
            setModalCteSemNota({ show: false })
          }}
          onError={onError}
        />
      </div>
    </>
  )
}

function DataTableComponent({ entregas, onMenuItemClicked }) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')

  // Helpers

  function verifyMenuItemAllowed(menuItem) {
    return menuItemsAllowed([menuItem]).length > 0
  }

  function menuItems() {
    const MENU_ITEMS = []

    if (verifyMenuItemAllowed({ id: 40, content: "3.18 - Gestão de CTe's" })) {
      MENU_ITEMS.push('Emitir CTe')
    }

    return MENU_ITEMS
  }
  // Render
  return (
    <DataTable
      value={entregas}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
      paginator={true}
      rows={10}
    >
      <Column field="identifier" header="Identif." style={tableCellCentered(150)} />
      <Column field="nomeFantasia" header="Fantasia" />
      <Column field="city" header="Cidade" />
      <Column field="district" header="Bairro" />
      <Column field="qteSkuTotal" header="Qte. Sku" style={tableCellCentered()} />
      <Column
        field="status"
        header="Status"
        style={tableCellCentered(130)}
        body={entrega => <BadgeStatusEntrega status={entrega.status} />}
      />
      <Column
        header="Dt. Status"
        body={entrega => <DateTime>{entrega.dt_status}</DateTime>}
        style={tableCellCentered(130)}
      />
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={entrega => (
          <ThreeDots items={menuItems()} onClick={item => onMenuItemClicked(item, entrega)} />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(EmissaoCte))
